import { getServerApi } from '../../../config/deployment'
import { performRequest_GET, performRequest_POST } from '../../utils/http/httpService'
import { getCurrentUserToken } from '../../auth/services/authService'
import { upsertPrivatePerson, upsertJurPerson } from "@/platform/person/repository/personRepository";
let envUri = getServerApi()
let accountUri = envUri + '/api/accounts'

const getCurrentUserAccounts = () => {
  return new Promise((resolve, reject) => {
    getCurrentUserToken()
      .then(token => {
        return performRequest_GET(accountUri, null, { "Authorization": token })
      })
      .then(resp => {
        if (resp.success) resolve(resp.response.data.body)
        else reject(resp.error)
      })
      .catch(err => {
        reject(err)
      })
  })
}

const getAccountPersons = (accountId) => {
  return new Promise((resolve, reject) => {
    getCurrentUserToken()
      .then(token => {
        return performRequest_GET(accountUri + "/persons", { accountId: accountId, token: token })
      })
      .then(resp => {
        if (resp.success) resolve(resp.response.data.body)
        else reject(resp.error)
      })
      .catch(err => {
        reject(err)
      })
  })
}

const addJurPersonToAccount = ({ person, privPersonId, connectionType, accountId }) => {
  if (!accountId || !person) return Promise.reject("specify accountId and person")
  else return upsertJurPerson({ person, privPersonId, connectionType, accountId })
}

const addPrivPersonToAccount = ({ person, accountId }) => {
  if (!accountId || !person) return Promise.reject("specify accountId and person")
  else return upsertPrivatePerson({ person, accountId })
}


export { getCurrentUserAccounts, getAccountPersons, addJurPersonToAccount, addPrivPersonToAccount }


// WEBPACK FOOTER //
// ./src/platform/account/services/accountService.js